import { SelectSearchableVariant } from '@hse-design/core';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Vue } from 'vue-property-decorator';
import { EnumProp } from '../../utils/enumProp.js';
import __vue_component__ from '../HseDropdownMenu/HseDropdownMenu.vue.js';
import __vue_component__$1 from '../HseDropdownMenu/HseDropdownMenuMessage.vue.js';

var HseSelectDropdown = /** @class */ (function (_super) {
    __extends(HseSelectDropdown, _super);
    function HseSelectDropdown() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(HseSelectDropdown.prototype, "dropdownMenuMessageClasses", {
        get: function () {
            return {
                dropdownMenuMessage: this.classes.dropdownMenuMessage,
                SelectDropdown__message_searchable_dropdown: this.searchable === SelectSearchableVariant.dropdown
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSelectDropdown.prototype, "isBorderless", {
        get: function () {
            return (!!this.message &&
                !this.$slots.default &&
                this.searchable === SelectSearchableVariant.inline);
        },
        enumerable: false,
        configurable: true
    });
    HseSelectDropdown.prototype.refRoot = function () {
        return this.$refs.root.$refs.root;
    };
    HseSelectDropdown.prototype.refItems = function () {
        return this.$refs.root.$refs.items;
    };
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseSelectDropdown.prototype, "isOpen", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], HseSelectDropdown.prototype, "message", void 0);
    __decorate([
        Prop({
            default: function () { return ({}); }
        }),
        __metadata("design:type", Object)
    ], HseSelectDropdown.prototype, "classes", void 0);
    __decorate([
        Prop(EnumProp(SelectSearchableVariant.inline, SelectSearchableVariant, [false])),
        __metadata("design:type", Object)
    ], HseSelectDropdown.prototype, "searchable", void 0);
    HseSelectDropdown = __decorate([
        Component({
            name: 'HseSelectDropdown',
            components: {
                HseDropdownMenu: __vue_component__,
                HseDropdownMenuMessage: __vue_component__$1
            }
        })
    ], HseSelectDropdown);
    return HseSelectDropdown;
}(Vue));

export default HseSelectDropdown;
